import React, { useState, useEffect } from 'react';
import styles from './FilterSection.module.css';
import CategoryPicker from './CategoryPicker';
import PeriodPicker from './PeriodPicker';
import { useModal } from './ModalProvider';
import filters from '../assets/filter.png';
import { LocateMe } from './LocateMe';
import { useSharedState } from '../hooks/useSharedState';
import { FilterModal } from './FilterModal';

interface FilterSectionProps {
    
}

const FilterSection: React.FC<FilterSectionProps> = () => {

    const [categories, setCategories] = useSharedState('categories', '');
    const [free, setFree] = useSharedState('free', '');
    const [isScrolled, setIsScrolled] = useState(false);

    const { show, hide } = useModal();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 250) {//was 50 before
                setIsScrolled(true);
                //setIsExpanded(false); // Minimize if scrolled
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleFree = () => {
        setFree(free == '1' ? '0' : '1');
    };

    return (
        <div className={[styles.filterSection, isScrolled ? styles.scrolled : ''].join(' ')}>

            <div className={styles.filterContentDesktop}>
                <CategoryPicker selectedCategories={categories.split(';')} onChange={(cats) => setCategories(cats.join(';'))} />
                <LocateMe />
                <button type="button" className={[styles.freeButton, free == '1' ? styles.selected : ''].join(' ')} onClick={toggleFree}>Gratuit {free=='1'&&<>✓</>}</button>
                <PeriodPicker />
            </div>

            <div className={styles.filterContentMobile}>
                
                    <div className={styles.filterMinimized} onClick={() => {
                        show(<FilterModal hide={hide} />);
                    }}>
                        <div className={styles.filterBtn}>
                            <div>
                                <img src={filters} width="20" height="20" alt="Filtres"/>
                                Filtres
                            </div>
                            <div>{categories == '' ? "Toutes catégories" : (categories.split(';').length + " catégorie" + (categories.split(';').length > 1 ? 's' : ''))}</div>
                        </div>
                    </div>
                
            </div>
        </div>
    );
};

export default FilterSection;
